import { SxProps, Theme, useMediaQuery, useTheme } from '@mui/material'
import Box from '@mui/material/Box'

import GoBackButton from 'components/GoBackButton/GoBackButton'
import {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react'
import { ResponsiveBoxWrapper } from './Layout.styled'

type LayoutProps = {
  sidebar: ReactNode
  sx?: SxProps<Theme>
}

interface SideBarUiProps {
  showOverlay: boolean
  setShowOverlay: Dispatch<SetStateAction<boolean>>
}

const SideBarUiContext = createContext<SideBarUiProps | null>(null)

const LayoutWithSecondarySidebar: FC<LayoutProps> = ({
  sidebar,
  children,
  sx,
}) => {
  const [showOverlay, setShowOverlay] = useState(true)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <SideBarUiContext.Provider value={{ showOverlay, setShowOverlay }}>
      <Box
        display='flex'
        alignItems='flex-start'
        height='100%'
        width='calc(100vw - 40px)'
        sx={{ overflow: 'auto' }}>
        {sidebar}
        <ResponsiveBoxWrapper sx={sx} showOverlay={showOverlay}>
          {isMobile && <GoBackButton onClick={() => setShowOverlay(false)} />}
          {children}
        </ResponsiveBoxWrapper>
      </Box>
    </SideBarUiContext.Provider>
  )
}

export default LayoutWithSecondarySidebar

export const useSideBarUiContext = () =>
  useContext(SideBarUiContext) as SideBarUiProps
